module.exports = ["dvigatel","kuzov","otoplenie-i-konditsionirovanie","pritsepnoe-oborudovanie","razborka","rulevoe-upravlenie","salon","toplivnaya-sistema","tormoznaya-sistema","hodovaya"]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/firstSeoRubricsTypes.json
// module id = 1257
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 15 16 17 18 19 20 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46